import lang from '../../../lib/language';
import { ETF_SECTOR_NAME } from '../../../lib/services/fundamental/helpers';
import { SectorEnum } from '../../../lib/store/fundamental/types';

import BasicMaterials from '../../../assets/popularGroupsLogos/BasicMaterials.png';
import Communications from '../../../assets/popularGroupsLogos/Communications.png';
import ConsumerDiscretionary from '../../../assets/popularGroupsLogos/ConsumerDiscretionary.png';
import ConsumerStaples from '../../../assets/popularGroupsLogos/ConsumerStaples.png';
import Energy from '../../../assets/popularGroupsLogos/Energy.png';
import ETFs from '../../../assets/popularGroupsLogos/ETFs.png';
import FinancialServices from '../../../assets/popularGroupsLogos/FinancialServices.png';
import Healthcare from '../../../assets/popularGroupsLogos/Healthcare.png';
import Industrials from '../../../assets/popularGroupsLogos/Industrials.png';
import RealEstate from '../../../assets/popularGroupsLogos/RealEstate.png';
import Technology from '../../../assets/popularGroupsLogos/Technology.png';
import Utilities from '../../../assets/popularGroupsLogos/Utilities.png';

const groups = {
  ETFs: {
    logo: ETFs,
    name: lang.popularGroupETFs(),
    sectorName: ETF_SECTOR_NAME,
  },
  CommunicationServices: {
    logo: Communications,
    name: lang.popularGroupCommunications(),
    sectorName: SectorEnum.CommunicationsServices,
  },
  HealthCare: {
    logo: Healthcare,
    name: lang.popularGroupHealthcare(),
    sectorName: SectorEnum.HealthCare,
  },
  ConsumerDiscretionary: {
    logo: ConsumerDiscretionary,
    name: lang.popularGroupConsumerDiscretionary(),
    sectorName: SectorEnum.ConsumerDiscretionary,
  },
  Technology: {
    logo: Technology,
    name: lang.popularGroupTechnology(),
    sectorName: SectorEnum.Technology,
  },
  Utilities: {
    logo: Utilities,
    name: lang.popularGroupUtilities(),
    sectorName: SectorEnum.Utilities,
  },
  ConsumerStaples: {
    logo: ConsumerStaples,
    name: lang.popularGroupConsumerStaples(),
    sectorName: SectorEnum.ConsumerStaples,
  },
  Financials: {
    logo: FinancialServices,
    name: lang.popularGroupFinancialServices(),
    sectorName: SectorEnum.Financials,
  },
  Materials: {
    logo: BasicMaterials,
    name: lang.popularGroupBasicMaterials(),
    sectorName: SectorEnum.Materials,
  },
  RealEstate: {
    logo: RealEstate,
    name: lang.popularGroupRealEstate(),
    sectorName: SectorEnum.RealEstate,
  },
  Industrials: {
    logo: Industrials,
    name: lang.popularGroupIndustrials(),
    sectorName: SectorEnum.Industrials,
  },
  Energy: {
    logo: Energy,
    name: lang.popularGroupEnergy(),
    sectorName: SectorEnum.Energy,
  },
};

export default groups;
